import React, { useEffect, useState } from "react";
import { Row, Col } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { toggleProduct } from "../actions/productActions";
import Loader from "./Loader";

const CardList = ({
  match,
  title,
  reading,
  readingDate,
  unit,
  bgColour,
  colour,
  icon,
  status,
  product,
}) => {
  // const productId = match.params.id;
  // console.log("DATA", product);
  const buttonStatus = product?.gensetControl === "X" ? true : false;
  // console.log("buttonStatus", buttonStatus);
  const [toggle, setToggle] = useState(buttonStatus || null);
  const dispatch = useDispatch();
  const userLogin = useSelector((state) => state.userLogin);
  const { userInfo } = userLogin;

  useEffect(() => {
    // console.log("Toggle DATA", toggle);
    if (product && toggle !== null) {
      const data = {
        _id: product._id,
        toggle,
      };
      console.log("Toggle NEW DATA", data);
      dispatch(toggleProduct(data));
    }
  }, [toggle]);

  useEffect(() => {
    // console.log("Toggle DATA", toggle);
    if (product && product.getsetStatus === "ON") {
      setToggle(true);
    }
    if (product && product.getsetStatus === "OFF") {
      setToggle(false);
    }
  }, [product && product.getsetStatus]);
  useEffect(() => {
    // console.log("Toggle DATA", toggle);

    if (product && product.gensetRealStatus === 1) {
      setToggle(false);
    }
    if (product && product.gensetRealStatus === 3) {
      setToggle(true);
    }
  }, [product && product.gensetRealStatus]);

  return (
    <div
      className={`tw-font-nunito tw-text-center tw-bg-gray-100 tw-py-3 tw-m-2 sm:tw-w-1/6 tw-w-4/5 
      tw-rounded-md tw-shadow-md tw-bg-${bgColour}-500 tw-text-${colour}`}
    >
      <Row className="tw-flex tw-justify-evenly tw-items-center tw-px-3">
        <Col
          xs={7}
          className="sm:tw-text-center tw-text-left sm:tw-text-xl tw-text-lg tw-font-bold"
        >
          {title}
        </Col>
        <Col xs={5}>
          <i className={`${icon} fa-lg`}></i>
        </Col>
      </Row>
      {reading && (
        <p className="sm:tw-text-2xl tw-text-xl tw-pt-3 tw-mb-0">
          {reading} {unit}
        </p>
      )}
      {readingDate && (
        <p className="sm:tw-text-xl tw-text-lg tw-px-3 tw-pt-3 tw-mb-0">
          {readingDate} {unit}
        </p>
      )}
      {}
      {product && product.getsetStatus && (
        <div className="tw-flex tw-flex-col tw-items-center tw-justify-center tw-pt-3">
          {/* Loading State */}
          {product &&
            product.gensetControl === "X" &&
            product.getsetStatus === "OFF" && (
              <strong className={`mt-2 tw-animate-pulse`}>
                <Loader />
              </strong>
            )}
          {product &&
            product.gensetControl === "Y" &&
            product.getsetStatus === "ON" && (
              <strong className={`mt-2 tw-animate-pulse`}>
                <Loader />
              </strong>
            )}

          {/* {product &&
            product.gensetControl === "X" &&
            product.getsetStatus === "OFF" && (
              <strong
                className={`mt-2 tw-animate-pulse ${
                  product && product.gensetControl === "X"
                    ? "tw-text-green-600"
                    : "tw-text-red-500"
                }`}
              >
                Switching{" "}
                {product && product.gensetControl === "X" ? "ON" : "OFF"}
                ...
              </strong>
            )}
          {product &&
            product.gensetControl === "Y" &&
            product.getsetStatus === "ON" && (
              <strong
                className={`mt-2 tw-animate-pulse ${
                  product && product.gensetControl === "X"
                    ? "tw-text-green-500"
                    : "tw-text-red-500"
                }`}
              >
                Switching{" "}
                {product && product.gensetControl === "X" ? "ON" : "OFF"}
                ...
              </strong>
            )} */}

          {/* OFF STATE */}
          {product &&
            product.gensetControl === "Y" &&
            product.getsetStatus === "OFF" && (
              <div className="tw-flex tw-flex-col">
                <div
                  className={`md:tw-w-14 md:tw-h-7 tw-w-12 tw-h-6 tw-flex tw-items-center tw-rounded-full tw-p-1 tw-cursor-pointer tw-bg-red-200`}
                  onClick={() => {
                    if (userInfo.role !== "MAIN_ADMIN")
                      setToggle(true);
                  }}
                >
                  <div
                    className={` md:tw-w-6 md:tw-h-6 tw-h-5 tw-w-5 tw-rounded-full tw-shadow-md tw-transform tw-bg-red-500`}
                  ></div>
                </div>
                <strong
                  className={`mt-2 ${
                    product && product.gensetControl === "X"
                      ? "tw-text-green-500"
                      : "tw-text-red-500"
                  }`}
                >
                  {product && product.gensetControl === "X" ? "ON" : "OFF"}
                </strong>
              </div>
            )}
          {/* ON STATE */}
          {product &&
            product.gensetControl === "X" &&
            product.getsetStatus === "ON" && (
              <div className="tw-flex tw-flex-col">
                <div
                  className={`md:tw-w-14 md:tw-h-7 tw-w-12 tw-h-6 tw-flex tw-items-center tw-rounded-full tw-p-1 tw-cursor-pointer tw-bg-green-200`}
                  onClick={() => {
                    if (userInfo.role !== "MAIN_ADMIN") setToggle(false);
                  }}
                >
                  <div
                    className={` md:tw-w-6 md:tw-h-6 tw-h-5 tw-w-5 tw-rounded-full tw-shadow-md tw-transform tw-translate-x-6 tw-bg-green-500`}
                  ></div>
                </div>
                <strong
                  className={`mt-2 ${
                    product && product.gensetControl === "X"
                      ? "tw-text-green-500"
                      : "tw-text-red-500"
                  }`}
                >
                  {product && product.gensetControl === "X" ? "ON" : "OFF"}
                </strong>
              </div>
            )}
        </div>
      )}
    </div>
  );
};

export default CardList;
